/* MARQUE v49: copy verified discount without external trackers or blocking checkout. */
(() => {
  'use strict';
  if (window.marquePromoCopyInitialized) return;
  window.marquePromoCopyInitialized = true;
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-marque-copy-code]');
    if (!button) return;
    event.preventDefault();
    const code = button.getAttribute('data-code');
    if (code !== 'MARQUE10') return;
    const group = button.closest('[data-marque-offer]') || button.closest('[data-marque-featured-offer]');
    const status = group?.querySelector('[data-marque-copy-status]');
    const word = button.querySelector('[data-marque-copy-text]');
    let copied = false;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
        copied = true;
      }
    } catch (e) { copied = false; }
    // Keep code visible even in browsers blocking clipboard permissions.
    if (copied) {
      if (word) word.textContent = 'Copied';
      if (status) status.textContent = 'MARQUE10 copied. Paste it in the discount field at checkout.';
    } else {
      if (word) word.textContent = 'MARQUE10';
      if (status) status.textContent = 'Enter MARQUE10 in the discount field at checkout.';
    }
  });
})();
